import { render } from "./DrawerMenu.vue?vue&type=template&id=347dbfc2&scoped=true"
import script from "./DrawerMenu.vue?vue&type=script&lang=js"
export * from "./DrawerMenu.vue?vue&type=script&lang=js"

import "./DrawerMenu.vue?vue&type=style&index=0&id=347dbfc2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347dbfc2"]])

export default __exports__